import './FHIRQueryRequestComposer.scss';
import { Base_RequestMessageComposer } from '../../Page_BaseSandbox/Base_RequestMessageComposer/index.js';
import { EditableItem } from '@nu-art/thunderstorm-frontend/index';
import { __stringify, isValidJson } from '@nu-art/ts-common';
import { ModuleFE_SandboxFHIRQuery } from '../../modules/ModuleFE_SandboxFHIRQuery/index.js';
export class FHIRQueryRequestComposer extends Base_RequestMessageComposer {
    static defaultProps = {
        module: ModuleFE_SandboxFHIRQuery
    };
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        // Auto save is true for now to make sure the entire thing updates on every change
        state.editable = new EditableItem(isValidJson(state.templateString) ? JSON.parse(state.templateString) : {}).setSaveAction(async (item) => {
            this.setState({ templateString: __stringify(item, true) });
            return item;
        });
        state.isStructured ??= false;
        return state;
    }
    sendRequest = async () => {
        if (this.state.templateString.length === 0) {
            this.logError('Can\'t send empty FHIR query');
            return;
        }
        return await ModuleFE_SandboxFHIRQuery.sendRequest(this.state.selectedTemplate, this.state.templateString);
    };
}
//# sourceMappingURL=FHIRQueryRequestComposer.js.map